(function(){

"use strict";

const Ghost={};

Ghost.reveal=function(){

const items=document.querySelectorAll(
".step,.stat-card,.glass-card,.compliance-card,.serve-card,.team-card,.faq-item"
);

const observer=new IntersectionObserver(entries=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add("visible");

}

});

},{
threshold:.15
});

items.forEach(item=>observer.observe(item));

};

Ghost.counter=function(){

const section=document.querySelector(".stats-section");

if(!section) return;

if(section.dataset.done) return;

const run=()=>{

if(section.dataset.done) return;

const rect=section.getBoundingClientRect();

if(rect.top<window.innerHeight*0.85){

section.dataset.done=true;

document.querySelectorAll(".number").forEach(counter=>{

const target=parseInt(counter.dataset.target);

const duration=1800;

const start=performance.now();

function animate(time){

const progress=Math.min((time-start)/duration,1);

counter.innerText=Math.floor(progress*target);

if(progress<1){

requestAnimationFrame(animate);

}else{

counter.innerText=target;

}

}

requestAnimationFrame(animate);

});

window.removeEventListener("scroll",run);

}

};

window.addEventListener("scroll",run,{passive:true});

window.addEventListener("touchmove",run,{passive:true});

window.addEventListener("load",run);

setTimeout(run,800);

};

Ghost.process=function(){

const slider=document.querySelector(".process-flow");

if(!slider) return;

let pause=false;

slider.addEventListener("mouseenter",()=>pause=true);

slider.addEventListener("mouseleave",()=>pause=false);

slider.addEventListener("touchstart",()=>pause=true);

slider.addEventListener("touchend",()=>pause=false);

function loop(){

if(!pause){

slider.scrollLeft+=0.5;

if(slider.scrollLeft>=slider.scrollWidth-slider.clientWidth){

slider.scrollLeft=0;

}

}

requestAnimationFrame(loop);

}

loop();

};

Ghost.faq=function(){

document.querySelectorAll(".faq-question").forEach(button=>{

button.onclick=function(){

this.parentElement.classList.toggle("active");

};

});

};

Ghost.init=function(){

Ghost.reveal();

Ghost.counter();

Ghost.process();

Ghost.faq();

};

document.addEventListener("shopify:section:load",Ghost.init);

document.addEventListener("DOMContentLoaded",Ghost.init);

window.addEventListener("load",Ghost.init);

})();